import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CustomRadioField, CustomSelectField } from '../../../components';
import formUtils from '../../../utils/formUtils';

function DisabilitySection({ militaryEnums, collected_attributes, intl, hasVAServiceDisability }) {
  return (
    <>
      {collected_attributes.military_service_connected_disability && (
        <CustomRadioField
          name="military.service_connected_disability"
          label={<FormattedMessage id="pUa8AK" description="hasVARatedSCDisability" defaultMessage="Has VA-rated Service-Connected Disability?" />}
          id="uu_contact_military_connected_disability"
          options={formUtils.translateOptions(intl, militaryEnums.connected_disability)}
        />
      )}
      {hasVAServiceDisability && collected_attributes.military_service_connected_disability_rating && (
        <CustomSelectField
          name="military.service_connected_disability_rating"
          id="uu_contact_military_service_connected_disability_rating"
          label={<FormattedMessage id="Lh1DOl" description="scDisabilityRating" defaultMessage="Service-Connected Disability Rating" />}
          options={formUtils.translateOptions(intl, militaryEnums.disability_rating)}
          shouldSort={false}
        />
      )}
    </>
  );
}

DisabilitySection.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
  collected_attributes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  hasVAServiceDisability: PropTypes.bool.isRequired,
};

export default DisabilitySection;
